import { type FC, createContext, useContext, useState } from 'react'

import { type Channel } from 'pusher-js'

export const UserContext = createContext<any>({})

export const UserProvider: FC<{
    children: JSX.Element | JSX.Element[]
}> = ({ children }) => {
    const [notificationsChannel, setNotificationsChannel] = useState<Channel>()

    return (
        <UserContext.Provider
            value={{
                notificationsChannel,
                setNotificationsChannel
            }}
        >
            {children}
        </UserContext.Provider>
    )
}

export const useUserContext = () => useContext(UserContext)
